module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "part",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_vm._v("Translator’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In Joalian and related dialects, a geographic name usually consists of a root modified by a prefix. English equivalents (for example Narshland, Narshvale, Narshia, etc.) fail to convey all the subtleties of the original. Joalian alone has twelve words to describe a mountain pass, depending on its difficulty, but no word for a mountain range.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The flora and fauna of the Vales are quite unrelated to terrestrial types, but convergent evolution has tended to fill similar ecological niches with species of similar appearance. Form follows function—a beetle is more or less a beetle anywhere, airborne species lay eggs so that they need not be burdened with immature young, and so on. To avoid overloading the reader’s memory with names and the page with italics, I have either coined descriptive terms (“bellfruit”) or assigned names on the basis of appearance. A rose is a rose is, sort of, a rose. The correspondence may be superficial; a “moa” is a bipedal mammal.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Time and distance have been converted to familiar units.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Spelling has been made as phonetic as possible, based on common English pronunciation. "), _c('em', {
    staticClass: "em"
  }, [_vm._v("G")]), _vm._v(" is hard; "), _c('em', {
    staticClass: "em"
  }, [_vm._v("c")]), _vm._v(" is used only in "), _c('em', {
    staticClass: "em"
  }, [_vm._v("ch, x")]), _vm._v(" and "), _c('em', {
    staticClass: "em"
  }, [_vm._v("q")]), _vm._v(" not at all.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Masculine gender words begin with hard consonants (b,d,g,k,p,t), feminine with vowels or aspirates (a,e,i,o,u,y,h), and neuter with soft consonants (f,j,l,m,n,r,s,th). Abstract concepts have their own declensions and begin with v,ch,w, or z.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Dissimilar vowels are pronounced separately, as if marked with a dieresis: "), _c('em', {
    staticClass: "em"
  }, [_vm._v("Eleal")]), _vm._v(" is pronounced "), _c('em', {
    staticClass: "em"
  }, [_vm._v("El-eh-al")]), _vm._v(", not "), _c('em', {
    staticClass: "em"
  }, [_vm._v("Eleel")]), _vm._v(". Double vowels indicate a long sound: "), _c('em', {
    staticClass: "em"
  }, [_vm._v("aa")]), _vm._v(" as in "), _c('em', {
    staticClass: "em"
  }, [_vm._v("late, ee")]), _vm._v(" as in "), _c('em', {
    staticClass: "em"
  }, [_vm._v("feet, ii")]), _vm._v(" as in "), _c('em', {
    staticClass: "em"
  }, [_vm._v("fight, oo")]), _vm._v(" as in "), _c('em', {
    staticClass: "em"
  }, [_vm._v("goat, uu")]), _vm._v(" as in "), _c('em', {
    staticClass: "em"
  }, [_vm._v("boot")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "normal _idGenParaOverride-1"
  }, [_vm._v("The English word "), _c('em', {
    staticClass: "em"
  }, [_vm._v("candle")]), _vm._v(" is pronounced "), _c('em', {
    staticClass: "em"
  }, [_vm._v("cand’l")]), _vm._v(". Joalian contains many such unvoiced vowels, which are indicated with an apostrophe. The initial consonant in "), _c('em', {
    staticClass: "em"
  }, [_vm._v("D’ward")]), _vm._v(" would be stressed more than in English "), _c('em', {
    staticClass: "em"
  }, [_vm._v("dwarf")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92044096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PastImperative5.vue
// module id = 84
// module chunks = 0